import { CurrencyPipe, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeNl from '@angular/common/locales/nl';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

registerLocaleData(localeNl);
registerLocaleData(localeEn);

/**
 * `currency`, but in the buyer's language: Angular's own pipe formats with the static `LOCALE_ID`
 * (en-US), so a Dutch checkout printed `€13.00` where it should print `€ 13,00` (PAUL-3203).
 * Impure because the active language is set after bootstrap; the output is cached per input.
 */
@Pipe({ name: 'localeCurrency', standalone: true, pure: false })
export class LocaleCurrencyPipe implements PipeTransform {
  private readonly currencyPipe = new CurrencyPipe('en', 'EUR');
  private lastKey: string;
  private lastResult: string | null = null;

  constructor(private translocoService: TranslocoService) {}

  transform(
    value: number | string | null | undefined,
    currencyCode = 'EUR',
    display: 'code' | 'symbol' | 'symbol-narrow' | string | boolean = 'symbol',
    digitsInfo?: string
  ): string | null {
    const locale = this.translocoService.getActiveLang() === 'en' ? 'en' : 'nl';
    const key = `${value}|${currencyCode}|${display}|${digitsInfo}|${locale}`;
    if (key !== this.lastKey) {
      this.lastKey = key;
      this.lastResult = this.currencyPipe.transform(value, currencyCode || 'EUR', display, digitsInfo, locale);
    }
    return this.lastResult;
  }
}
